import { render, staticRenderFns } from "./DashboardConfigSideDrawer.vue?vue&type=template&id=03c1d7cf&"
import script from "./DashboardConfigSideDrawer.vue?vue&type=script&lang=js&"
export * from "./DashboardConfigSideDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports